var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMetricsColorPavilion = function SvgMetricsColorPavilion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m22.836 26.754.797 18.477-14.386-5.959zM38.753 39.273 24.367 45.23l.77-18.467zM21.227 25.12l-12.5 13.633L2.77 24.367zM39.273 38.753 26.767 25.13l18.464-.763zM21.227 22.88l-18.458.753L8.728 9.247zM45.231 23.633l-18.464-.764L39.273 9.247zM38.753 8.728 25.148 21.24l-.78-18.471zM22.978 21.19 9.248 8.729l14.385-5.96z"
  })));
};
export default SvgMetricsColorPavilion;